// src/components/Transaction/Ethereum/TxErc20Transfers/aggrid/columnDefs.ts
import { ColDef } from 'ag-grid-community';
import { AddressCellRenderer } from 'src/components/Address/EvmChains/aggrid/cellRenderers/AddressCellRenderer';
import { BlockCellRenderer } from 'src/components/Address/EvmChains/aggrid/cellRenderers/BlockCellRenderer';
import { TimestampCellRenderer } from 'src/components/Address/EvmChains/aggrid/cellRenderers/TimestampCellRenderer';
import { AmountCellRenderer } from 'src/components/Address/EvmChains/aggrid/cellRenderers/AmountCellRenderer';
import { AssetCellRenderer } from 'src/components/Address/EvmChains/aggrid/cellRenderers/AssetCellRenderer';

const blockColDef: ColDef = {
  field: 'block',
  headerName: 'Block',
  width: 150,
  sortable: true,
  headerClass: 'font-bold',
  cellRenderer: BlockCellRenderer,
  filter: 'agNumberColumnFilter',
};

const timestampColDef: ColDef = {
  field: 'timestamp',
  headerName: 'Time',
  width: 180,
  sortable: true,
  headerClass: 'font-bold',
  cellRenderer: TimestampCellRenderer,
  filter: false,
};

const fromColDef: ColDef = {
  field: '_from',
  headerName: 'From',
  flex: 1,
  headerClass: 'font-bold',
  cellRenderer: AddressCellRenderer,
  cellRendererParams: {
    columnId: 'from',
  },
  filter: 'agTextColumnFilter',
};

const toColDef: ColDef = {
  field: '_to',
  headerName: 'To',
  flex: 1,
  headerClass: 'font-bold',
  cellRenderer: AddressCellRenderer,
  cellRendererParams: {
    columnId: 'to',
  },
  filter: 'agTextColumnFilter',
};

const amountColDef: ColDef = {
  field: 'amount',
  headerName: 'Amount',
  flex: 1,
  sortable: true,
  headerClass: 'font-bold',
  cellRenderer: AmountCellRenderer,
  filter: 'agNumberColumnFilter',
};

const assetColDef: ColDef = {
  field: 'tokenMetadata',
  headerName: 'Asset',
  width: 150,
  headerClass: 'font-bold',
  cellRenderer: AssetCellRenderer,
  filter: 'agTextColumnFilter',
  valueGetter: (params) => {
    const tokenMetadata = params.data.tokenMetadata;
    if (!tokenMetadata) return '';
    return `${tokenMetadata.display_name || tokenMetadata.symbol || ''}`;
  },
};

// ERC20 transfers column definitions - similar to combinedColDefs but without transaction hash
export const erc20TransfersColDefs: ColDef[] = [
  blockColDef,
  timestampColDef,
  fromColDef,
  toColDef,
  amountColDef,
  assetColDef,
];
